module.exports = __webpack_public_path__ + "img/About.5012adfa.png";